export default {
  TITLE: 'title',
  ALT: 'alt',
  DESCRIPTION: 'description',
  USE_TITLE_FOR_ALT: 'useTitleForAlt',
};
